// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./bockDammMug.jpg')
const allTwoEs = require('./static-2.jpg')
const allTwoCa = require('./static-2.jpg')
const allFourEs = require('./static-2.jpg')
const allFourCa = require('./static-2.jpg')
const catalogTwoEs = require('./static-2.jpg')
const catalogTwoCa = require('./static-2.jpg')
const catalogFourEs = require('./static-2.jpg')
const catalogFourCa = require('./static-2.jpg')

const model = creativityMediaModel({
  catalogID: 'glassware',
  allTwoEs,
  allTwoCa,
  allFourEs,
  allFourCa,
  catalogTwoEs,
  catalogTwoCa,
  catalogFourEs,
  catalogFourCa
})

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) =>
    model[params.catalogID][params.numberOfColumns][params.language]
}
